var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { IdDoghouse } from "../../constants/IdDoghouse";
import { utilTime } from "../../utils/utilTime";
import { TypeActionDoghouse } from "./actionDoghouse";
var initial = {
    cooldownTime: 0,
};
export var reducerDoghouse = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionDoghouse.GiveTreat:
            return __assign({}, state, { cooldownTime: action.isRepeat
                    ? 0
                    : utilTime.timestamp(IdDoghouse.GiveDogtreatCooldown) });
        case TypeActionDoghouse.FinishTreatCooldown:
            return __assign({}, state, { cooldownTime: 0 });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/reducerDoghouse.ts
// module id = 2525
// module chunks = 3